<button mat-icon-button [matMenuTriggerFor]="notificationMenu">
  <mat-icon
    matBadgeColor="warn"
    aria-hidden="false"
    [matBadge]="(unreadCount$ | async) || 0"
    [matBadgeHidden]="(unreadCount$ | async) === 0">
    notifications
  </mat-icon>
</button>

<mat-menu #notificationMenu="matMenu" class="notification-menu">
  <div class="notification-header">
    <h3>Notifications</h3>
    <div class="header-actions">
      <button mat-icon-button matTooltip="Mark all as read" (click)="markAllAsRead()">
        <mat-icon>drafts</mat-icon>
      </button>
      <button mat-icon-button color="warn" matTooltip="Clear all" (click)="clearAll()">
        <mat-icon>delete_sweep</mat-icon>
      </button>
    </div>
  </div>

  <div class="notification-list">
    @for (pool of pooledNotifications$ | async | keyvalue; track pool.key) {
      <div class="notification-pool">
        <h4 class="pool-title">{{ pool.key }}</h4>
        <mat-divider />
        @for (notification of pool.value; track notification.id) {
          <div
            class="notification-item"
            [id]="'notification-' + notification.id"
            [class.unread]="!notification.read"
            [attr.data-type]="notification.type">
            <mat-icon class="notification-icon">
              {{ iconForType[notification.type] }}
            </mat-icon>
            <div class="notification-content">
              <div class="notification-meta">
                <span class="notification-type">
                  {{ notification.type | titlecase }}
                </span>
                <span class="notification-timestamp">
                  {{ notification.timestamp | date: 'short' }}
                </span>
              </div>
              <div class="notification-message">
                {{ notification | translateNotification }}
              </div>
            </div>
            <div class="item-actions">
              <button mat-icon-button [matMenuTriggerFor]="itemActions" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #itemActions="matMenu">
                @if (notification.details) {
                  <button mat-menu-item (click)="showDetails(notification.details)">
                    <mat-icon>visibility</mat-icon>
                    <span>Details</span>
                  </button>
                }
                <button mat-menu-item (click)="markAsRead(notification.id)">
                  <mat-icon>drafts</mat-icon>
                  <span>Mark as read</span>
                </button>
                <button mat-menu-item (click)="deleteNotification(notification.id)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          </div>
        }
      </div>
    } @empty {
      <div class="empty-state">
        <mat-icon>notifications_off</mat-icon>
        <p>No new notifications</p>
      </div>
    }
  </div>
</mat-menu>
